import React from 'react'
import AboutHero from '../components/AboutHero'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import OurStory from '../components/OurStory'
import ManufacturingFacility from '../components/ManufacturingFacility'
import WhyWeStarted from '../components/WhyWeStarted'
import OurUSPAndImpact from '../components/OurUSPAndImpact'
import WhyChooseUsCTA from '../components/WhyChooseUsCTA'

const About = () => {
  return (
    <div className="site-page">
        <Navbar/>
      <AboutHero/>
      <OurStory/>
      <ManufacturingFacility/>
      <WhyWeStarted/>
      <OurUSPAndImpact/>
      <WhyChooseUsCTA/>
      <Footer/>
    </div>
  )
}

export default About
